import React from 'react';

const FormSuccess = () => {
  return (
    <div className='form-content-right'>
      <h1 className='form-success'>Thanks for your Message !</h1>
    </div>
  );
};

export default FormSuccess;
